// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"027e1b99","25":"649782aa","240":"0e373564","250":"1b517d1f","282":"c4df708c","456":"c950f1e0"}[chunkId] + ".chunk.css";
};